<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">Mis Datos</b-card-header>
      <b-card-body>
        <div class="row form-group">
          <div class="col-md-12 text-center">
            <img
              :src="model.Image"
              class="rounded-circle"
              @click="misImagenes"
              style="width: 150px; cursor: pointer"
              alt
            />
            <img
              src="/img/ico_camera_profile.png"
              style="width:40px;height:40px;vertical-align: bottom;margin-left: -39px;"
              @click="misImagenes"
            />
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <label>Nombre</label>
            <base-input v-model="model.Name" placeholder="Ejemplo: Juan" readonly></base-input>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <label>Apellido</label>
            <base-input v-model="model.Surname" placeholder="Ejemplo: Gomez" readonly></base-input>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-10">
            <label>Mail</label>
            <base-input
              v-model="model.Mail"
              name="email"
              placeholder="Ejemplo: mail@mail.com"
              readonly
            ></base-input>
          </div>

          <div class="col-xl-2" style="display: flex; align-items:center; padding-top: 10px;">            
            <b-button variant="outline-success" class="btnValidar" style="width:100% !important" @click="emailValidation">Cambiar</b-button>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <label>Fecha de nacimiento</label>
            <div v-if="this.model.EnabledBirthDate">
              <KitsDate v-model="model.BirthDate" :currentValue="model.BirthDate" />
              <!-- <datetime v-model="model.BirthDate" input-class="form-control" type="date" zone="utc" moment-locale="es" :phrases="{ok: 'Aceptar', cancel: 'Cancelar'}"></datetime> -->
            </div>
            <div v-else>
              <base-input v-model="model.FormatedBirthDate" readonly></base-input>
            </div>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <label>Localidad</label>
            <KitsBusquedaSimple
              url="City/GetTopByText"
              v-model="Localidad"
              :currentValue="Localidad"
            />
          </div>
        </div>

        <!-- LOCALIDAD -->

        <div class="row form-group">
          <div class="col-md-12">
            <label>Calle</label>
            <base-input v-model="model.Street" placeholder="Escribí la calle"></base-input>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <label>Número</label>
            <base-input v-model="model.StreetNumber" placeholder="Escribí el número de dirección"></base-input>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <label>Piso</label>
            <base-input v-model="model.Floor"></base-input>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <label>Departamento</label>
            <base-input v-model="model.Department"></base-input>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <label>Tipo de documento</label>
            <KitsCombo
              v-model="model.DocumentTypeID"
              v-bind:items="tiposdocumentos"
              propertyName="Name"
              propertyID="EntityID"
              :todos="false"
            ></KitsCombo>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <label>Documento</label>
            <base-input v-model="model.DocumentNumber" readonly></base-input>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <label>Sexo</label>
            <KitsCombo
              v-model="model.GenderID"
              v-bind:items="sexos"
              propertyName="Name"
              propertyID="EntityID"
              nullText=" -- Seleccione un sexo -- "
              :todos="true"
              readonly
            ></KitsCombo>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-md-12">
            <label>Compañia</label>
            <KitsCombo
              v-model="model.TelephoneCompanyID"
              v-bind:items="companias"
              propertyName="Name"
              propertyID="EntityID"
              nullText=" -- Seleccione un compañía -- "
              :todos="true"
            ></KitsCombo>
          </div>
        </div>

        <div class="row form-group">
          <div class="col-xl-3">
            <label>Prefijo</label>
            <base-input v-model="model.Prefix" type="number" onlyNumbers :maxlength="5" readonly></base-input>
          </div>
          <div class="col-xl-7">
            <label>Número</label>
            <base-input v-model="model.Telephone" type="number" onlyNumbers :maxlength="8" readonly></base-input>            
          </div>
          <div class="col-xl-2" style="display: flex; align-items:center; padding-top: 10px;">            
            <b-button variant="outline-danger" class="btnValidar" style="width:100% !important" v-if="!isPhoneVerify" @click="phoneValidation">Validar</b-button>
            <b-button variant="outline-success" class="btnValidar" style="width:100% !important" v-else @click="phoneValidation">Cambiar</b-button>
          </div>
        </div>
        
        <div class="row form-group">
          <div class="col-md-12 text-center">
            <save-button @click="pinValidate"></save-button>
          </div>
        </div>
      </b-card-body>
    </b-card>
    <pin-validation ref="pin-validation"
        :showModal.sync="showModalPinValidation"
        v-on:validPin="onValidPin"
        v-on:loadUsePaymentPin="onLoadUsePaymentPin">
    </pin-validation>
  </div>
</template>

<style scoped>
    @media (min-width: 1200px) {
      .btnValidar{
        margin-left:50px;
      }
    }
</style>

<script>
// ******************** Select ********************//
import Vue from "vue";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
// ******************** Select ********************//

import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";

import KitsCombo from "@/components/KitsCombo";
import KitsDate from "@/components/KitsDate";
import KitsBusquedaSimple from "@/components/KitsBusquedaSimple";
import PinValidation from '@/views/Pin/PinValidation';

export default {
  components: { KitsCombo, KitsBusquedaSimple, KitsDate, "pin-validation": PinValidation},
  data() {
    return {
      model: {
        AccountID: null,
        CityID: null,
        CityName: "",
        Street: "",
        StreetNumber: "",
        Floor: "",
        Department: "",
        Name: "",
        Surname: "",
        DocumentTypeID: null,
        DocumentNumber: "",
        LandLane: "",
        TelephoneCompanyID: null,
        GenderID: null,
        Prefix: "",
        Telephone: "",
        BirthDate: "",
        Image: "",
        Mail: "",
        FormatedBirthDate: "",
        EnabledBirthDate: false
      },
      tiposdocumentos: [],
      sexos: [],
      companias: [],
      Localidad: null,
      tiposdocumentosready: false,
      sexosready: false,
      companiasready: false,
      isPhoneVerify: false,
      usePaymentPin: false,
      showModalPinValidation: false,
      OldMail: "",
    };
  },
  methods: {
    misImagenes() {
      this.$router.push("misimagenes");
    },
    guardar() {
      let context = this;

      if (this.numerocompleto.length != 0 && this.numerocompleto.length != 10) {
        notificationHelpers.showWarning(
          "Advertencia!",
          "El Prefijo y el Numero deben sumar 10 dígitos",
          context
        );
        return;
      }

      this.$validator.validate().then(valid => {
        if (valid) {
          axiosHelpers.axiosPost(
            "Account/MyProfileSave",
            {
              CityID: context.Localidad != null ? context.Localidad.ID : 0,
              Street: context.model.Street,
              StreetNumber: context.model.StreetNumber,
              Floor: context.model.Floor,
              Department: context.model.Department,
              Name: context.model.Name,
              Surname: context.model.Surname,
              DocumentTypeID: context.model.DocumentTypeID,
              DocumentNumber: context.model.DocumentNumber,
              LandLane: context.model.LandLane,
              TelephoneCompanyID: context.model.TelephoneCompanyID,
              GenderID: context.model.GenderID,
              Prefix: context.model.Prefix,
              Telephone: context.model.Telephone,
              BirthDate: context.model.BirthDate,
              Mail: context.model.Mail
            },
            this,
            function(data) {
              if (data.ResponseVM.Resultado) {
                if (!data.ResponseVM.IsMailVerificated) {           
                  context.$store.dispatch("logout").then(() => {
                      notificationHelpers.showSuccess("Mis datos", "Se han modificado correctamente sus datos. Por favor, ingrese nuevamente.", context);
                      context.$router.push("login");
                  });                
                }
                else{
                  notificationHelpers.showSuccess(
                  "Exito!",
                  "Se guardaron sus datos correctamente",
                  context
                  );
                }
                
              }              
            }
          );
        } else {
          notificationHelpers.showWarning(
            "Advertencia!",
            "Verifique todos los campos",
            context
          );
        }
      });
    },
    emailValidation(){
      let context = this;

      if (context.$store.getters.ShouldPerformTwoStepVerification == true) {
         context.$router.push({name:"selectSecurityMethod", params:{
                    accumulationMethodTypeID: context.$store.getters.PERSONAL_DATA_UPDATE_ATTEMPTS_METHOD_TYPE_ID,
                    useRouterPush: true, dataPost:{name:"EmailValidation", params:{
                    url: "/miperfilp"
            }}
            }});
      } else {
         context.$router.push({name:"EmailValidation", params:{
                    url: "/miperfilp"
            }});
      }
    },
    phoneValidation(){
      let context = this;

      if (context.$store.getters.ShouldPerformTwoStepVerification == true) {
                  context.$router.push({name:"selectSecurityMethod", params:{
                    accumulationMethodTypeID: context.$store.getters.PERSONAL_DATA_UPDATE_ATTEMPTS_METHOD_TYPE_ID,
                    useRouterPush: true, dataPost:{name:"PhoneValidation", params:{
                    url: "/miperfilp"
            }}
            }});
      } else{
           context.$router.push({name:"PhoneValidation", params:{
                    Prefix: context.model.Prefix,
                    Telephone:context.model.Telephone,
                    url: "/miperfilp"
            }});
      }
    },
    cargarModel() {
      if (this.tiposdocumentosready && this.sexosready && this.companiasready) {
        let context = this;
        axiosHelpers.axiosGet("Account/MyProfile", {}, this, function(data) {
          context.model = data.ResponseVM;
          context.OldMail = data.ResponseVM.Mail;
          context.FormatedBirthDate = data.ResponseVM.FormatedBirthDate;
          context.EnabledBirthDate = data.ResponseVM.EnabledBirthDate;

          if (context.model.CityID != 0) {
            context.Localidad = {
              ID: context.model.CityID,
              Text: context.model.CityName
            };
          }
        });
      }
    },
    onValidPin(val){
      let context = this;
      if(val) {
          context.guardar();
      }
    },
    onLoadUsePaymentPin(val){
      let context = this;
      context.usePaymentPin = val;
    },
    pinValidate() {
      let context = this;
      let newMail = context.model.Mail;
      if(context.usePaymentPin && (newMail != context.OldMail)) {
          context.showModalPinValidation = true;
      } else {
          context.guardar();
      }
    }
  },
  computed: {
    numerocompleto: function() {
      let prefijo = "";
      let numero = "";

      if (this.model.Prefix != null) {
        prefijo = this.model.Prefix;
      }
      if (this.model.Telephone != null) {
        numero = this.model.Telephone;
      }

      return prefijo + numero;
    },
    fullLoaded: function() {
      return (
        this.tiposdocumentosready && this.sexosready && this.companiasready
      );
    }
  },
  mounted: function() {
    let context = this;
    context.isPhoneVerify = context.$store.getters.IsPhoneVerify;
  },
  beforeMount: function() {
    let context = this;

    axiosHelpers.axiosGet("DocumentType/GetAll", {}, this, function(data) {
      context.tiposdocumentos = data.ResponseVM;
      context.tiposdocumentosready = true;
    });

    axiosHelpers.axiosGet("Gender/GetAll", {}, this, function(data) {
      context.sexos = data.ResponseVM.Genders;
      context.sexosready = true;
    });

    axiosHelpers.axiosGet("TelephoneCompany/GetAll", {}, this, function(data) {
      context.companias = data.ResponseVM;
      context.companiasready = true;
    });
  },
  watch: {
    tiposdocumentosready: function(newValue, oldValue) {
      this.cargarModel();
    },
    sexosready: function(newValue, oldValue) {
      this.cargarModel();
    },
    companiasready: function(newValue, oldValue) {
      this.cargarModel();
    }
  }
};
</script>